import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectPlan, setPlan } from '../paywallSlice';
import AppButton from './components/AppButton';
import PlansDescription from './PlansDescription';
import { Cost, Description, ImgWrapper, StyledImage, StyledItem, StyledList, Title } from './styles/trialStyles';

export const TrialGzPlans = ({ onBuyClick }) => {
    const dispatch = useDispatch();
    const plan = useSelector(selectPlan);
    const [price, setPrice] = useState('$16.51');
    const TRIAL_PLANS = useMemo(
        () => [
            {
                id: 'gz-1-month-intro7d-100-2999',
                price: '$1',
            },
            {
                id: 'gz-1-month-intro7d-500-2999',
                price: '$5',
            },
            {
                id: 'gz-1-month-intro7d-1000-2999',
                price: '$10',
            },
            {
                id: 'gz-1-month-intro7d-1651-2999',
                price: '$16.51',
            },
        ],
        []
    );
  
    useEffect(() => {
        dispatch(setPlan(TRIAL_PLANS[3].id));
    }, [dispatch, TRIAL_PLANS]);
  
    const onPlanClick = (id, price) => {
        dispatch(setPlan(id));
        setPrice(price);
    };

    const renderItem = (i, index) => {
        const isActive = plan === i.id;
        return (
            <StyledItem
                onClick={() => onPlanClick(i.id, i.price)}
                data-text={'Most popular choise'}
                active={isActive}
                key={index}
                id={`plan-button-${index + 1}`}
            >
                <span>{i.price}</span>
            </StyledItem>
        );
    };

    const continueButton = (displayStickyBtn, sticky) => (
        <AppButton
            onClick={onBuyClick}
            bottomPosition={'24px'}
            displayStickyBtn={displayStickyBtn}
            position={sticky}
            customStickyWidth={'100%'}
            customBeforeHeight={'0px'}
            displayStubBtn={false}
        >
            Continue
        </AppButton>
    );
    return (
        <>
            <ImgWrapper>
                <StyledImage src={'../images/plans/PayAnyPrice.png'} alt="Pay what you want" />
            </ImgWrapper>
            <Title>Pay what you want</Title>
            <Description>Money shouldn’t get in the way of finding a plan that finally works. Choose an amount that you think is reasonable to try us out for one week.</Description>
            <Cost>
                It costs us <span>{TRIAL_PLANS[3].price}</span> to compensate our Geozilla employees for the trial, but please choose the amount you are comfortable with.
            </Cost>
            <StyledList>{TRIAL_PLANS.map(renderItem)}</StyledList>
            {continueButton(true, 'sticky')}
            <PlansDescription
                continueButton={continueButton}
                showHint={`7-day ${price} trial, then $29.99/ month`}
            />
        </>
    );
};

export default TrialGzPlans;
